import type { FC, SVGProps } from 'react';

const GermanyIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Germany">
        <path
          id="Vector"
          d="M2.62109 15.4784C4.03402 19.2864 7.69945 22.0002 11.9991 22.0002C16.2987 22.0002 19.9642 19.2864 21.3771 15.4784L11.9991 14.6089L2.62109 15.4784Z"
          fill="#FFDA44"
        />
        <path
          id="Vector_2"
          d="M11.9991 2C7.69945 2 4.03402 4.71375 2.62109 8.52176L11.9991 9.39129L21.3771 8.52172C19.9642 4.71375 16.2987 2 11.9991 2Z"
          fill="black"
        />
        <path
          id="Vector_3"
          d="M2.62199 8.52148C2.22004 9.6048 2 10.7765 2 11.9997C2 13.2229 2.22004 14.3946 2.62199 15.478H21.378C21.78 14.3946 22 13.2229 22 11.9997C22 10.7765 21.78 9.6048 21.378 8.52148H2.62199Z"
          fill="#D80027"
        />
      </g>
    </svg>
  );
};

export default GermanyIcon;
